// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"d1161160","168":"1a917be3","280":"807859a7","332":"18c7046b","334":"360cd4ed","468":"23bc08fb","488":"35b82ae5","611":"39f84014","640":"a91cc39a","713":"9c8495a2","716":"1ca3f45c","725":"16ee39a4","822":"689e4a79","864":"35628745"}[chunkId] + ".chunk.js";
};